import React from 'react';
import Dict from 'dict-lib';
import {setEncy} from './SenseAction';
import {Grid, Row, InputGroup, FormGroup, FormControl, Button} from 'react-bootstrap';
import './../../../../_css/lexeme.css';

import stylesLexemeSenses from './../../../../_css/dictionary/lexemeParts/lexemeSenses.module.css';
import {LexemeUtilities} from "../LexemeHelper";
import ReactDom from "react-dom";
import {SCSubmitButton} from "../../../../dict-components/submitButton/SCSubmitButton";
import {AdministrationUtilities} from "../../../../administration/AdministrationHelper";
import BUtils from "../../../../utilities/BaseUtilities";
import {TreeNodeHelper} from "../../../../dict-components/tree/components/TreeHelper";
import {Notifications} from "../../../../utilities/DictUtilities";

export class SenseEncyclopedicInfos extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            id: this.props.id,
            editor: null,
            tinyRowClass: 'aftiny-init',
            encyclopedic_infos: '',
            saving: false
        };

        this.descrLanguage = typeof this.props.context.descrLanguage === 'undefined' ? AdministrationUtilities.getDescriptionLanguage(this.props.context.languageId).code : this.props.context.descrLanguage;
        this.ids = this.props.item.ids;

        this._performSave = this._performSave.bind(this);
        this._save = this._save.bind(this);
        this._saveAndClose = this._saveAndClose.bind(this);
        this._closeFastEdit = this._closeFastEdit.bind(this);
    }

    componentDidMount() {
        var code = this.descrLanguage;


        //var selector = this.props.fastEdit ? `#${'fast-ency'}` : `#${'ency'}`;
        var selector = `#ency_${this.ids}`;

        const editorExists = tinymce.get(`ency_${this.ids}`);

        var retrieveHtml = new Promise((resolve) => {
            return resolve(this.props.html);

        });

        retrieveHtml.then((html) => {
            if(editorExists)
                editorExists.remove();
            this.setState({item: this.props.item, html}, () => {
                tinymce.init({
                    selector: selector,
                    height: 200,
                    min_height: 200,
                    menubar: '',
                    plugins: 'link image code sccharmap',
                    toolbar: 'ency | undo redo | bold italic | alignleft aligncenter alignright | code | sccharmap | close saveandclose save',
                    setup: editor => {
                        editor.addButton('ency', {
                            text: this.descrLanguage,
                            type: 'label'
                        });
                        editor.addButton('close', {
                            text: Dict.t('CLOSE'),
                            icon: false,
                            cmd: 'close'
                        });
                        editor.addButton('save', {
                            text: Dict.t('SAVE'),
                            icon: false,
                            cmd: 'save'
                        });
                        editor.addButton('saveandclose', {
                            text: Dict.t('SAVE_AND_CLOSE'),
                            icon: false,
                            cmd: 'saveandclose'
                        });
                        this.setState({editor: editor}, () => {
                            editor.focus();
                        });
                        editor.on('keyup change', () => {
                            const html = editor.getContent();
                            this.setState({html});
                        });
                        editor.addCommand('save', this._save);
                        editor.addCommand('saveandclose', this._saveAndClose);
                        editor.addCommand('close', this._closeFastEdit);
                    }
                });
            });
        })


        setTimeout(function () {
            this.setState({
                tinyRowClass: 'aftiny-mount'
            })
        }.bind(this), 500);
    }

    componentWillUnmount() {
        //tinymce.remove(this.state.editor);
    }

    _closeFastEdit() {
        this.props.callbackParent('close', this.state.saving ? this.state.html : null);
    }

    _saveAndClose() {
        return this._performSave(() => {
            this.props.callbackParent('save_and_close', this.state.html);

        });
    }

    _save() {
        return this._performSave(() => {
            this.props.callbackParentSaveOnly('save', this.state.html);

        });
    }

    _performSave(callback) {
        const html = this.state.html;
        Notifications.showModalSpinner(Dict.t('SAVING'));

        this.setState({saving: true}, () => {
            Dict.call('/entry/retrieveMediaData', {
                method: 'POST',
                data: html,
                headers: {}
            }).then((result) => {
                    setEncy(this.props.item.ids, result.filename, this.descrLanguage).then((res) => {
                        //if (this.props.fastEdit) {
                        if (typeof callback === 'function')
                            callback(res, html);
                        Notifications.closeModalSpinner();
                        this.setState({saving: false});
                    });
                }
            );
        });
    }


    render() {

        return <Grid className="tiny-af-container" fluid>
            <Row className={this.state.tinyRowClass}>
                <textarea
                    id={`ency_${this.ids}`}
                    placeholder="textarea"
                    ref={(input) => {
                        this.ency = input;
                    }}
                    value={this.state.html}
                />
                {/*<FormGroup>
                    <FormControl id={`ency_${this.ids}`}
                                 componentClass="textarea"
                                 placeholder="textarea"
                                 ref={(input) => {
                                     this.ency = input;
                                 }}
                                 value={this.state.html}/>
                </FormGroup>*/}
                {/*!this.props.fastEdit ? <Row
                    className={BUtils.joinClasses("row-bt-advancedFields " + this.state.tinyRowClass, stylesLexemeSenses['sense_encyclopedic_edit_buttons_container'])}>
                    {}
                    <SCSubmitButton onClick={this._save} text={Dict.t('SAVE')}/>
                </Row> : ''*/}
            </Row>
        </Grid>
    }
}
